/**
 * ExistingSettings - 기존 설정 표시 컴포넌트
 *
 * Phase 1 리팩토링: Settings.tsx에서 분리
 */
import React from 'react';

interface APIKeysResponse {
  has_api_key: boolean;
  has_secret_key: boolean;
  crypto_enabled: boolean;
  api_key_preview: string | null;
}

interface ExistingSettingsProps {
  settings: APIKeysResponse;
}

const ExistingSettings: React.FC<ExistingSettingsProps> = ({ settings }) => {
  if (!settings.has_api_key) {
    return null;
  }

  return (
    <div className="existing-settings">
      <h3>현재 설정</h3>
      <div className="setting-item">
        <label>API Key:</label>
        <span className="masked-key">{settings.api_key_preview}</span>
      </div>
      <div className="setting-item">
        <label>Secret Key:</label>
        <span className="masked-key">
          {settings.has_secret_key ? '●●●●●●●●' : '설정 안 됨'}
        </span>
      </div>
      <div className="setting-item">
        <label>암호화폐 거래:</label>
        <span>폐기됨</span>
      </div>
    </div>
  );
};

export default ExistingSettings;
